import { useState } from 'react';

import { humanizeEnum } from '../utils';

export function useTableSorting<KeyType>(defaultValue = '') {
  const [sortKey, setSort] = useState<KeyType>(defaultValue as KeyType);
  const [sortDir, setSortDir] = useState(1);

  const toggleSort = (key: KeyType) => () => {
    if (key === sortKey) {
      setSortDir(sortDir * -1);
    } else {
      setSort(key);
    }
  };

  const headerCell = (key: KeyType) => {
    return {
      onClick: toggleSort(key),
      sortDir,
      active: sortKey === key,
      role: 'button' as const,
      tabIndex: 0,
      'aria-label': `Sort by ${humanizeEnum(key as string)} in ${sortDir === 1 ? 'ascending' : 'descending'} order`,
      // eslint-disable-next-line no-nested-ternary
      'aria-sort': sortKey === key ? (sortDir === 1 ? ('ascending' as const) : ('descending' as const)) : undefined,
    };
  };

  return {
    headerCell,
    sortDir,
    sortKey,
  };
}
